import { primitive } from 'styles/constants';

import { AppTakeoverConfig, TakeoverMenuSectionConfig, TakeoverPdpItemConfig } from '../types';

import { HeroBottomGradient } from './HeroBottomGradient';
import { ConfirmHeaderOverlay } from './confirm-header-overlay';
import { HeaderFlair } from './header-flair';

export const BROWN = '#803F20';
const GROGU_GREEN = '#AFCF91';
const GROGU_GREEN_DARK = '#95B475';
const SAND = '#FDD07C';
const SAND_LIGHT = '#FDF5E6';

const ITEM_CONFIG_BASE: TakeoverPdpItemConfig = {
  sectionBackgroundColor: SAND_LIGHT,
};

const MEAL_ITEM_CONFIG: TakeoverPdpItemConfig = {
  ...ITEM_CONFIG_BASE,
  cartItemBackgroundImage: require('./meal-cart-item-background.webp'),
  cartItemImage: require('./meal-cart-item.webp'),
};

const KIDS_ITEM_CONFIG: TakeoverPdpItemConfig = {
  ...ITEM_CONFIG_BASE,
  cartItemBackgroundImage: require('./kids-cart-item-background.webp'),
  cartItemImage: require('./kids-cart-item.webp'),
};

const SECTION_CONFIG_BASE: TakeoverMenuSectionConfig = {
  headerBackgroundColor: SAND,
  itemBackgroundColor: SAND_LIGHT,
  footerImage: require('./section-footer.webp'), // mountain background
  footerImageOffset: 60,
};

const MEALS_SECTION_CONFIG: TakeoverMenuSectionConfig = {
  // desert background image, mando profile pic
  ...SECTION_CONFIG_BASE,
  sectionTileBackgroundImage: require('./meals-section-tile-bg.webp'),
  sectionTileImage: require('./meals-section-tile.webp'),
  titleMaxWidth: 125,
  sectionTileImageStyle: {
    width: 100,
    aspectRatio: 1,
  },
};

const KIDS_SECTION_CONFIG: TakeoverMenuSectionConfig = {
  // green background image, grogu profile pic
  ...SECTION_CONFIG_BASE,
  sectionTileBackgroundImage: require('./kids-menu-section-tile-bg.webp'),
  sectionTileImage: require('./kids-section-tile.webp'),
  titleMaxWidth: 125,
  sectionTileImageStyle: {
    width: 100,
    aspectRatio: 1,
  },
};

export const mandalorian: AppTakeoverConfig = {
  menuIcon: require('./menu-icon.webp'),
  menuIconActive: require('./menu-icon-active.webp'),
  primaryActionButton: {
    backgroundColor: GROGU_GREEN,
    borderColor: GROGU_GREEN_DARK,
    borderWidth: 2,
    _text: {
      color: primitive.$bbqBrown,
    },
    _pressed: {
      backgroundColor: '#90B56C',
    },
  },
  homePage: {
    targetSimpleHomePageIds: [
      // dev lunch simple home page
      '6cc4cd5a-9a89-49ca-a683-b5c741359b81',
      // staging/prod SHP
      '55e96472-e610-4279-a2fa-646253da0982',
      // CA
      '0b0cb38a-c85c-4f21-95de-27b6ca9eabdc',
    ],
    showReplayButton: true,
    containerBackgroundColor: BROWN,
    HeroBottomGradient,
    deliveryButton: {
      _text: {
        color: primitive.$white,
      },
      borderColor: primitive.$white,
    },
  },
  menu: {
    targetSectionIds: {
      // dev testing
      '463b62de-01b7-4af7-b5ea-6d6337dfb142': MEALS_SECTION_CONFIG, // meals (testing)
      section_5603: KIDS_SECTION_CONFIG, // kids (testing)
    },
  },

  pdp: {
    targetMenuItemIds: {
      // dev testing meals
      'ec9b5960-3068-40ef-93d3-4837a687042c': MEAL_ITEM_CONFIG,
      '756793e9-12b7-4627-a1a8-238295605570': MEAL_ITEM_CONFIG,
      '22407a11-b4ce-4778-bc73-1bdb5e193771': MEAL_ITEM_CONFIG,
      //dev testing kids
      combo_5796: KIDS_ITEM_CONFIG,
    },
    headerFontColor: primitive.$white,
    headerBackgroundColor: '#53230B',
    backgroundColor: '#FFF8DC',
    overviewTopImage: require('./pdp-overview-top.webp'),
    overviewBottomImage: require('./pdp-overview-bottom.webp'),
    overviewBottomImageOffset: 100,
    summaryPageBackgroundImage: require('./pdp-summary-page-bg.webp'),
    summaryPageTextColor: primitive.$white,
    HeaderFlair,
  },
  cart: {
    paymentProcessingVideo: require('./checkout.mp4'),
    paymentProcessingBackgroundColor: '#D97C31',
  },
  orderConfirmDetails: {
    headerImage: require('./order-confirm-details-header.webp'),
    ConfirmHeaderOverlay,
    headerFontColor: primitive.$white,
  },
};
